import imgOne from '../../assets/blogs/1.png';
import imgTwo from '../../assets/blogs/2.png';
import imgThree from '../../assets/blogs/3.png';

const BlogData = [
    {
    'img': imgOne,
    'url': 'new-technology-make-for-dental-operation',
    'title': 'New Technology Make for Dental Operation',
    'description': 'Discover how cutting-edge technology is transforming dental procedures for a more efficient experience.',
    'category': 'TECHNOLOGY'
},
{
    'img': imgTwo,
    'url': 'regular-dental-care-make-your-smile-brighter',
    'title': 'Regular Dental Care Makes Your Smile Brighter',
    'description': 'Maintaining regular dental care is the key to achieving a healthy and radiant smile.',
    'category': 'DENTAL'
},
{
    'img': imgThree,
    'url': 'dental-hygiene-for-all-age-to-make-smile',
    'title': 'Dental Hygiene for All Age Groups to Make Smile',
    'description': 'Good dental hygiene is essential for all age groups to preserve oral health and confidence.',
    'category': 'HYGIENE'
}

];

export default BlogData;